import { render, staticRenderFns } from "./NoPrintPage.vue?vue&type=template&id=bd6f4354&"
import script from "./NoPrintPage.vue?vue&type=script&lang=js&"
export * from "./NoPrintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports